export enum BannerActionTypes {
    ADD_BANNER_MESSAGE = "ADD_BANNER_MESSAGE",
    CLOSE_BANNER_MESSAGE = "CLOSE_BANNER_MESSAGE",
}